/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, Col, FormGroup, Label, Button,
         ButtonToolbar, ButtonGroup, Row, FormFeedback } from 'reactstrap'
import ReactTable from 'react-table-legacy'
import Select from 'react-select'
import { AppContext } from '../../AppContext'

class ObjectTypeDetail extends React.Component
{
  description = null;
  objectTypeChanged = false;
  buttonFeedback = null;
  originalObjectTypeData = null;
  embeddingTypes = [{embeddingType: 'text'},{embeddingType: 'image'}];

  closeModal()
  {
    if (this.objectTypeChanged)
    {
      this.context.postNotification('error', 'You have unsaved changes.  Save your changes or press the reset button.');
      return;
    }

    this.props.closeModal();
  }

  async componentDidMount()
  {
    if ('Y' !== this.props.objectTypeData.enabled) await this.getTablespaces();
  }

  constructor(props)
  {
    super();

    let hasFocus = 'description';
    if ('' === props.objectTypeData.objectType) hasFocus = 'objectType';
    if (undefined !== props.objectTypeData.objectTypeId && 'Y' !== props.objectTypeData.enabled) hasFocus = 'tablespaceName';
    
    this.originalObjectTypeData = JSON.parse(JSON.stringify(props.objectTypeData));
    this.state =
    {
      selectedTablespace: null !== props.objectTypeData.tablespaceName ? props.objectTypeData.tablespaceName : props.defaultLobTablespace,
      tablespaces: undefined,
      tableNameValid: undefined,
      columnNameValid: undefined,
      objectTypeValid: undefined,
      objectTypeData: Object.assign({}, props.objectTypeData),
      enableButtonDisabled: false,
      updateButtonDisabled: true,
      resetButtonDisabled: true,
      addExtButtonDisabled: false,
      hasFocus: hasFocus
    }

    this.enableVectorEmbedding = this.enableVectorEmbedding.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.enableObjectType = this.enableObjectType.bind(this);
    this.selectTSpaceHandler = this.selectTSpaceHandler.bind(this);
    this.selectDataTypeHandler = this.selectDataTypeHandler.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.setValue = this.setValue.bind(this);
    this.requiredField = this.requiredField.bind(this);
    this.renderFileExtension = this.renderFileExtension.bind(this);
    this.renderMimeType = this.renderMimeType.bind(this);
    this.renderHtmlElement = this.renderHtmlElement.bind(this);
    this.createFileExtension = this.createFileExtension.bind(this);
    this.updateObjectType = this.updateObjectType.bind(this);
    this.resetValues = this.resetValues.bind(this);
    this.renderVectorRow = this.renderVectorRow.bind(this);
    this.selectEmbeddingType = this.selectEmbeddingType.bind(this);
  }

  createFileExtension()
  {
    let objectTypeData = this.state.objectTypeData;
    let fileExtensions = [{dataChanged: true, extensionId: undefined, fileExtension: '', mimeType: 'application/octet-stream', htmlElement: null}];
    if (undefined !== objectTypeData.fileExtensions) fileExtensions = fileExtensions.concat(objectTypeData.fileExtensions)
    objectTypeData.fileExtensions = fileExtensions;
    this.setState(
    {
      objectTypeData: objectTypeData,
      resetButtonDisabled: false, 
      addExtButtonDisabled: true,
      hasFocus: 'fileExtension'
    });
    this.objectTypeChanged = true;
  }

  async createObjectType()
  {
    let bodyData = {};
    bodyData.objectType = this.state.objectTypeData.objectType;
    bodyData.tableName = this.state.objectTypeData.tableName;
    bodyData.columnName = this.state.objectTypeData.columnName;
    bodyData.dataType = this.state.objectTypeData.dataType;
    bodyData.description = this.state.objectTypeData.description;
    bodyData.htmlAcceptValue = this.state.objectTypeData.htmlAcceptValue;
    bodyData.fileExtensions = [];

    for (let x = 0; x < this.state.objectTypeData.fileExtensions.length; x++)
    {
      let extensionInfo = 
      {
        extensionId: null,
        fileExtension: this.state.objectTypeData.fileExtensions[x].fileExtension,
        mimeType: this.state.objectTypeData.fileExtensions[x].mimeType,
        htmlElement: this.state.objectTypeData.fileExtensions[x].htmlElement
      }
      bodyData.fileExtensions.push(extensionInfo);
    }

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createObjectType', bodyData);
    if ('success' !== result.status)
    {
      if (this.context.dbTwig.ObjectTypeExists === result.errorCode)
      {
        this.context.postNotification('error', 'The object type already exists.');
        return;
      }

      return this.context.dbTwig.apiErrorHandler(result, 'Error creating object type');
    } 

    this.objectTypeChanged = false;
    let objectTypeData = this.state.objectTypeData;
    objectTypeData.objectTypeId = result.jsonData.objectTypeId;
    objectTypeData.enabled = 'N';

    for (let x = 0; x < result.jsonData.fileExtensions.length; x++)
    {
      for (let y = 0; y < objectTypeData.fileExtensions.length; y++)
      {
        if (result.jsonData.fileExtensions[x].fileExtension === objectTypeData.fileExtensions[y].fileExtension)
        {
          objectTypeData.fileExtensions[y].extensionId = result.jsonData.fileExtensions[x].extensionId;
          break;
        }
      }
    }

    this.setState({objectTypeData: objectTypeData, updateButtonDisabled: true}); //, await this.getFileExtensions());
    this.originalObjectTypeData = JSON.parse(JSON.stringify(objectTypeData));
    this.context.postNotification('success', 'Object type created.');
  }

  async enableObjectType()
  {
    this.setState({enableButtonDisabled: true});

    let bodyData = {};
    bodyData.objectTypeId = this.state.objectTypeData.objectTypeId;
    bodyData.tablespaceName = this.state.selectedTablespace.tablespaceName;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'enableObjectType', bodyData);
    if ('success' !== result.status)
    {
      this.setState({enableButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error enabling object type');
    } 

    this.context.postNotification('info', 'Object type enabled.');
    let objectTypeData = this.state.objectTypeData;
    objectTypeData.enabled = 'Y';
    objectTypeData.tablespaceName = this.state.selectedTablespace.tablespaceName;  
    this.setState({enableButtonDisabled: false, objectTypeData: objectTypeData});
  }

  async enableVectorEmbedding()
  {
    if (null === this.state.objectTypeData.vectorModality)
    {
      this.context.postNotification('error', 'You must select a vector modality.');
      return;
    } 

    let bodyData = 
    {
      objectTypeId: this.state.objectTypeData.objectTypeId,
      vectorModality: this.state.objectTypeData.vectorModality
    };

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'enableVectorData', bodyData);
    if ('success' !== result.status)
    {
      this.setState({enableButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error enabling vector embedding');
    } 

    let objectTypeData = this.state.objectTypeData;
    objectTypeData.vectorDataEnabled = 'Y'
    this.setState({objectTypeData});
    this.context.postNotification('info', 'Vector embedding enabled.');
  }

  async getTablespaces()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getTablespaceList');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving tablespace list');

    this.setState({tablespaces: result.jsonData.tablespaceList});
  }

  isUpdateDisabled(objectTypeData)
  {
    this.buttonFeedback = 'You must specify an object type, table name, column name and at least one extension...';
    if ('' === objectTypeData.objectType || '' === objectTypeData.tableName ||
        '' === objectTypeData.columnName) return true;

    if (!this.state.objectTypeData.fileExtensions.length || '' === this.state.objectTypeData.fileExtensions[0].fileExtension || 
        '' === this.state.objectTypeData.fileExtensions[0].mimeType) return true;

    this.buttonFeedback = null;
    return false;
  }

  renderFileExtension(cellInfo)
  {  // Auto-focus for this field is FUBAR'd.  Looks to be a bug in the DOM.  Setting seems to be ignored.  Oh well...
    if (undefined === this.state.objectTypeData.fileExtensions || undefined === this.state.objectTypeData.fileExtensions[cellInfo.index]) return null;

    if (undefined === this.state.objectTypeData.fileExtensions[cellInfo.index].extensionId && 0 === cellInfo.index)
      return(
        <Input type="text" id="fileExtension" placeholder="<file-extension...>" 
          value={null === this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension ? '' : this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension} 
          onChange={this.setFileExtensionValue.bind(this, cellInfo.index)} autoFocus
        />);
    
    if (undefined === this.state.objectTypeData.fileExtensions[cellInfo.index].extensionId && 0 !== cellInfo.index)        
      return(
        <Input type="text" id="fileExtension" placeholder="<file-extension...>" 
          value={null === this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension ? '' : this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension} 
          onChange={this.setFileExtensionValue.bind(this, cellInfo.index)}
        />);

    return(
      <Input type="text" id="fileExtension" placeholder="<file-extension...>" 
        value={null === this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension ? '' : this.state.objectTypeData.fileExtensions[cellInfo.index].fileExtension} 
        onChange={this.setFileExtensionValue.bind(this, cellInfo.index)} disabled={true}
      />);
  }

  renderMimeType(cellInfo)
  {
    if (undefined === this.state.objectTypeData.fileExtensions || undefined === this.state.objectTypeData.fileExtensions[cellInfo.index]) return null;

    return(
      <Input type="text" id="mimeType" onChange={this.setFileExtensionValue.bind(this, cellInfo.index)} placeholder="application/octet-stream"
        value={null === this.state.objectTypeData.fileExtensions[cellInfo.index].mimeType ? '' : this.state.objectTypeData.fileExtensions[cellInfo.index].mimeType} 
      />);
  }

  renderHtmlElement(cellInfo)
  {
    if (undefined === this.state.objectTypeData.fileExtensions || undefined === this.state.objectTypeData.fileExtensions[cellInfo.index]) return null;

    return(
      <Input type="text" id="htmlElement" onChange={this.setFileExtensionValue.bind(this, cellInfo.index)}
        value={null === this.state.objectTypeData.fileExtensions[cellInfo.index].htmlElement ? '' : this.state.objectTypeData.fileExtensions[cellInfo.index].htmlElement} 
      />);
  }

  renderVectorRow()
  {
    if (window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI))
    {
      if ('Y' === this.state.objectTypeData.vectorDataEnabled)
        return(
          <FormGroup row>
            <Col sm='2'>Vector Modality</Col>
            <Col sm='1' ><Input value={this.state.objectTypeData.vectorModality} diabled={true} /></Col>
          </FormGroup>
        );
      else
        return(
          <FormGroup row>
            <Col sm='2'>Vector Modality</Col>
            <Col sm='2'>
              <Select id='embeddingType' value={{embeddingType: this.state.objectTypeData.vectorModality}} options={this.embeddingTypes}
                getOptionLabel={option => option.embeddingType} getOptionValue={option => option.embeddingType}
                onChange={this.selectEmbeddingType} isClearable={false}
              />
            </Col>
            <Col><Button color="primary" onClick={this.enableVectorEmbedding}>Enable</Button></Col>
          </FormGroup>
        );
    }
    return null;
  }

  render()
  {
    let valueRequired = 'A value is required for this field.';
    
    let objectVaultTypes = [];
    objectVaultTypes[0] = {typeName: 'BLOB'};
    objectVaultTypes[1] = {typeName: 'CLOB'};
    
    const columns = 
    [
      {Header: 'File Extension', accessor: 'fileExtension', Cell: this.renderFileExtension},
      {Header: 'Mime Type', accessor: 'mimeType', Cell: this.renderMimeType},
      {Header: 'HTML Element', accessor: 'htmlElement', Cell: this.renderHtmlElement},
      {accessor: 'extensionId', show: false}
    ];

//    let selectedTablespace = (null === this.state.selectedTablespace ? this.props.defaultLobTablespace : this.state.selectedTablespace);

    let tablespaceElement =
      <Select id='tablespaceName' value={this.state.selectedTablespace} options={this.state.tablespaces} 
        getOptionLabel={option => option.tablespaceName} getOptionValue={option => option.tablespaceName}
        onChange={this.selectTSpaceHandler} isClearable={false} autoFocus={'tablespaceName' === this.state.hasFocus ? true : false}
      />;

    let typeElement =
      <Select id='typeName' value={{typeName: this.state.objectTypeData.dataType}} options={objectVaultTypes}
        getOptionLabel={option => option.typeName} getOptionValue={option => option.typeName}
        onChange={this.selectDataTypeHandler} isClearable={false} 
      />;

    if ('Y' === this.state.objectTypeData.enabled)
    {
      tablespaceElement = 
        <Input id='tablespaceName' value={this.state.objectTypeData.tablespaceName} disabled={true} />

      typeElement =
        <Input id='typeName' value={this.state.objectTypeData.dataType} disabled={true} />
    }

    let enableButtonElement = null;
    
    if (undefined !== this.state.objectTypeData.enabled && 'N' === this.state.objectTypeData.enabled &&
        undefined !== this.state.objectTypeData.objectTypeId) 
      enableButtonElement = 
        (
          <Col sm="2">
            <Button color="primary" disabled={this.state.enableButtonDisabled} onClick={this.enableObjectType}>Enable</Button>
          </Col>
        );

    return(
      <div>
        <Modal className='modal-md' isOpen={this.props.isModalOpen} toggle={this.closeModal} autoFocus={false} >
          <ModalHeader toggle={this.closeModal}>Object Type Details</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup row>
                <Label for='tableName' sm='2'>Object Type</Label>
                <Col sm='4'>
                  <Input type="text" id="objectType" placeholder="<file-type>" value={this.state.objectTypeData.objectType} 
                    onChange={this.requiredField} disabled={'Y' === this.state.objectTypeData.enabled ? true : false}
                    invalid={(undefined === this.state.objectTypeValid ? undefined : !this.state.objectTypeValid)} 
                    valid={(undefined === this.state.objectTypeValid ? undefined : this.state.objectTypeValid)} 
                    autoFocus={'objectType' === this.state.hasFocus ? true : false}
                  />
                  <FormFeedback valid={false}>{valueRequired}</FormFeedback>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="tablespaceName" sm="2">Tablespace Name</Label>
                <Col sm="4">{tablespaceElement}</Col>
                {enableButtonElement}
              </FormGroup>
              <FormGroup row>
                <Label for='tableName' sm='2'>Table Name</Label>
                <Col sm='4'>
                  <Input type="text" id="tableName" placeholder="<table-name>" value={this.state.objectTypeData.tableName} 
                    onChange={this.requiredField} disabled={'Y' === this.state.objectTypeData.enabled ? true : false}
                    invalid={(undefined === this.state.tableNameValid ? undefined : !this.state.tableNameValid)} 
                    valid={(undefined === this.state.tableNameValid ? undefined : this.state.tableNameValid)} 
                  />
                  <FormFeedback valid={false}>{valueRequired}</FormFeedback>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='columnName' sm='2'>Column Name</Label>
                <Col sm='4'>
                  <Input type="text" id="columnName" placeholder="<column-name>" value={this.state.objectTypeData.columnName} 
                    onChange={this.requiredField} disabled={'Y' === this.state.objectTypeData.enabled ? true : false}
                    invalid={(undefined === this.state.columnNameValid ? undefined : !this.state.columnNameValid)} 
                    valid={(undefined === this.state.columnNameValid ? undefined : this.state.columnNameValid)} 
                  />
                  <FormFeedback valid={false}>{valueRequired}</FormFeedback>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='typeName' sm='2'>Data Type</Label>
                <Col sm='4'>{typeElement}</Col>
              </FormGroup>
              <FormGroup row>
                <Label for='description' sm='2'>Description</Label>
                <Col sm='4'>
                  <Input type="text" id="description" placeholder="<description>" onChange={this.setValue}
                    autoFocus={'description' === this.state.hasFocus ? true : false}
                    value={null === this.state.objectTypeData.description ? '' : this.state.objectTypeData.description}
                  />                  
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='htmlAcceptValue' sm='2'>HTML Accept Value</Label>
                <Col sm='4'>
                  <Input type="text" id="htmlAcceptValue" placeholder="<html-accept-value>" onChange={this.setValue} 
                    value={null === this.state.objectTypeData.htmlAcceptValue ? '' : this.state.objectTypeData.htmlAcceptValue} 
                  />
                </Col>
              </FormGroup>
              {this.renderVectorRow()}
              <Row>
                <Col sm='2'>File Extensions</Col>
                <Col sm='6'>
                  <ReactTable data={this.state.objectTypeData.fileExtensions} noDataText="No file extensions" 
                    columns={columns} minRows={1} pageSize={5} className="-striped -highlight"
                  />
                  <ButtonToolbar>
                    <ButtonGroup size="sm" style={{marginLeft: 'auto'}} >
                      <Button title="Create File Extension" color="transparent" onClick={this.createFileExtension}
                        disabled={this.state.addExtButtonDisabled}
                      >
                        <img src="assets/images/plus.png" alt="Create File Extension" />
                      </Button>
                    </ButtonGroup>
                  </ButtonToolbar>
                </Col>
              </Row>
              <Row style={{paddingTop: "10px"}}>
                <Col sm={{ size: 2, offset: 3 }}>
                  <Button title={this.buttonFeedback} color="primary" disabled={this.state.updateButtonDisabled} onClick={this.updateObjectType}>
                    {undefined === this.state.objectTypeData.objectTypeId ? 'Create' : 'Update'}
                  </Button>
                </Col>
                <Col sm={{ size: 2}}>
                  <Button id="cancelB" color="secondary" disabled={this.state.resetButtonDisabled} onClick={this.resetValues}>Reset</Button>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button className="margin-right" color="secondary" onClick={this.closeModal}>OK</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  requiredField(event)
  {
    let objectTypeData = this.state.objectTypeData;
    objectTypeData[event.target.id] = event.target.value;
    let valid = ('' === event.target.value ? false : true);
    let disabled = this.isUpdateDisabled(objectTypeData, this.state.objectTypeData.fileExtensions);
    this.setState(
    {
      objectTypeData: objectTypeData, 
      [event.target.id + 'Valid']: valid, 
      updateButtonDisabled: disabled,
      resetButtonDisabled: false
    });
    this.objectTypeChanged = true;
  }

  async resetValues()
  {
    let objectTypeData = 
    {
      objectTypeId: undefined, 
      objectType: '',
      enabled: undefined, 
      tableName: '', 
      columnName: '', 
      description: '', 
      htmlAcceptValue: '',
      dataType: 'BLOB',
    };

    if (undefined !== this.originalObjectTypeData) objectTypeData = this.originalObjectTypeData;
    if (null === objectTypeData.htmlAcceptValue) objectTypeData.htmlAcceptValue = '';
    if (null === objectTypeData.description) objectTypeData.description = '';

    this.setState(
    {
      selectedTablespace: null === this.props.objectTypeData.tablespaceName ? 
        { tablespaceName: this.props.objectTypeData.tablespaceName } : this.props.defaultLobTablespace,
      tableNameValid: undefined,
      columnNameValid: undefined,
      objectTypeData: objectTypeData,
      updateButtonDisabled: true,
      resetButtonDisabled: true,
      addExtButtonDisabled: false
    });

    this.objectTypeChanged = false;
    this.context.postNotification('info', 'Object type info reset.');
  }

  selectDataTypeHandler(selectedDataType, actionMetaD)
  {
    if (null === selectedDataType) return;
    let objectTypeData = this.state.objectTypeData;
    objectTypeData.dataType = selectedDataType.typeName;
    let disabled = this.isUpdateDisabled(objectTypeData, this.state.objectTypeData.fileExtensions);
    this.setState({objectTypeData: objectTypeData, updateButtonDisabled: disabled, resetButtonDisabled: false});
    this.objectTypeChanged = true;
  }

  selectEmbeddingType(selectedEmbeddingType, actionMetaD)
  {
    if (null === selectedEmbeddingType) return;
    let objectTypeData = this.state.objectTypeData;
    objectTypeData.vectorModality = selectedEmbeddingType.embeddingType;
    this.setState({objectTypeData: objectTypeData});
  }

  selectTSpaceHandler(selectedTablespace, actionMetaD)
  {
    if (null === selectedTablespace) return;
    this.setState({selectedTablespace: selectedTablespace });
  }

  setFileExtensionValue(index, event)
  {
    let objectTypeData = this.state.objectTypeData;
    objectTypeData.fileExtensions[index][event.target.id] = event.target.value;
    objectTypeData.fileExtensions[index].dataChanged = true;

    let disabled = false;
    if ('fileExtension' === event.target.id && '' === event.target.value)
    {
      this.context.postNotification('warning', 'You must supply a file extension.');
      disabled = true;
    }
    disabled = this.isUpdateDisabled(this.state.objectTypeData);

    this.setState({objectTypeData: objectTypeData, updateButtonDisabled: disabled, addExtButtonDisabled: disabled, resetButtonDisabled: false});
    this.objectTypeChanged = true;
  }

  setValue(event)
  {
    let objectTypeData = this.state.objectTypeData;
    objectTypeData[event.target.id] = event.target.value;
    let disabled = this.isUpdateDisabled(objectTypeData, this.state.objectTypeData.fileExtensions);
    this.setState({objectTypeData: objectTypeData, updateButtonDisabled: disabled, resetButtonDisabled: false});
    this.objectTypeChanged = true;
  }

  toggleCheckbox(event)
  {
    let objectTypeData = this.state.objectTypeData;
    if ('Y' === objectTypeData[event.target.id])
      objectTypeData[event.target.id] = 'N';
    else
      objectTypeData[event.target.id] = 'Y';

    let disabled = this.isUpdateDisabled(objectTypeData, this.state.objectTypeData.fileExtensions);
    this.setState({objectTypeData: objectTypeData, updateButtonDisabled: disabled, resetButtonDisabled: false});
    this.objectTypeChanged = true;
  }

  async updateObjectType()
  {
    if (undefined === this.state.objectTypeData.objectTypeId) return this.createObjectType();

    if (JSON.stringify(this.originalObjectTypeData) === JSON.stringify(this.state.objectTypeData))
    {
      this.objectTypeChanged = false;
      this.setState({updateButtonDisabled: true, resetButtonDisabled: true});
      return;
    }

    let bodyData = {};
    bodyData.objectTypeId = this.state.objectTypeData.objectTypeId;
    bodyData.objectType = this.state.objectTypeData.objectType;
    bodyData.tableName = this.state.objectTypeData.tableName;
    bodyData.columnName = this.state.objectTypeData.columnName;
    bodyData.dataType = this.state.objectTypeData.dataType;
    bodyData.description = this.state.objectTypeData.description;
    bodyData.htmlAcceptValue = this.state.objectTypeData.htmlAcceptValue;
    
    bodyData.fileExtensions = [];
    for (let x = 0; x < this.state.objectTypeData.fileExtensions.length; x++)
    {
      if (this.state.objectTypeData.fileExtensions[x].dataChanged)
      {
        let extensionInfo = 
        {
          extensionId: this.state.objectTypeData.fileExtensions[x].extensionId,
          fileExtension: this.state.objectTypeData.fileExtensions[x].fileExtension,
          mimeType: this.state.objectTypeData.fileExtensions[x].mimeType,
          htmlElement: this.state.objectTypeData.fileExtensions[x].htmlElement
        }

        bodyData.fileExtensions.push(extensionInfo);
      }
    }

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateObjectType', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating object type');

    this.objectTypeChanged = false;
    this.context.postNotification('info', 'Object type updated.');

    let objectTypeData = this.state.objectTypeData;
    for (let x = 0; x < result.jsonData.fileExtensions.length; x++)
    {
      for (let y = 0; y < objectTypeData.fileExtensions.length; y++)
      {
        if (result.jsonData.fileExtensions[x].fileExtension === objectTypeData.fileExtensions[y].fileExtension)
        {
          objectTypeData.fileExtensions[y].extensionId = result.jsonData.fileExtensions[x].extensionId;
          break;
        }
      }
    }

    this.setState({updateButtonDisabled: true, resetButtonDisabled: true, objectTypeData: objectTypeData});
    this.originalObjectTypeData = JSON.parse(JSON.stringify(objectTypeData));
  }
}

ObjectTypeDetail.contextType = AppContext;

export default ObjectTypeDetail
